import React from "react";
import PropTypes from "prop-types";
import { VstLoader } from "vstui";

class FigureCardContainer extends React.Component {
  render() {
    const {
      load,
      onClick,
      figure: { figureId, title, path, thumbnailURL, imageURL }
    } = this.props;
    if (load) {
      const figureBackgroundURL = path || thumbnailURL || imageURL;
      const figCaption = title ? " fig-caption-added" : "";
      return (
        <li
          id={`figure-${figureId}`}
          key={`figure-${figureId}`}
          className={"figure-list-item" + figCaption}
        >
          <figure>
            <button onClick={onClick}>
              <div>
                <img src={figureBackgroundURL} alt="" />
              </div>
              {
                <figcaption className="offScreen">
                  {title || i18n.t("reader.figures.no-title-provided")}
                </figcaption>
              }
            </button>
          </figure>
        </li>
      );
    }
    return (
      <li
        id={`figure-${figureId}`}
        key={`figure-${figureId}`}
        className="figure-list-item"
      >
        <VstLoader />
      </li>
    );
  }
}

FigureCardContainer.propTypes = {
  load: PropTypes.bool,
  enlargeFigure: PropTypes.func,
  figure: PropTypes.shape({
    load: PropTypes.bool,
    title: PropTypes.string,
    figureId: PropTypes.string,
    imageURL: PropTypes.string,
    thumbnailURL: PropTypes.string,
    caption: PropTypes.string
  })
};

FigureCardContainer.defaultProps = {
  load: false,
  figure: {}
};

module.exports = FigureCardContainer;
